import React, { Suspense, lazy } from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import { Layout } from "./utility/context/Layout"
import { RLayout } from "./utility/context/RLayout"
import * as serviceWorker from "./serviceWorker"
import { store } from "./redux/storeConfig/store"
import Spinner from "./components/@vuexy/spinner/Fallback-spinner"
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./index.scss"
import "./@fake-db"

import EventBus from './utility/EventBus';
window.eventBus = EventBus;

const LazyApp = lazy(() => import("./App"))

// <Suspense fallback={<Spinner />} >
// configureDatabase()
ReactDOM.render(
    <Provider store={store}>
      <Suspense fallback={''}>
        <ToastContainer />
        <Layout>
        {/*  <RLayout>*/}
            <LazyApp />
          {/*</RLayout>*/}
        </Layout>
      </Suspense>
    </Provider>,
  document.getElementById("root")
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
